// src/services/tokenService.js
import { jwtDecode } from 'jwt-decode';

const KEY_TOKEN = 'lms_token';
const KEY_PROFILE_DETAIL = 'lms_profile_detail';

export default {
    setToken(token) {
        localStorage.setItem(KEY_TOKEN, token);
    },

    getToken() {
        return JSON.parse(localStorage.getItem(KEY_TOKEN));
    },

    removeToken() {
        localStorage.removeItem(KEY_TOKEN);
    },

    setProfileDetail(profile) {
        localStorage.setItem(KEY_PROFILE_DETAIL, JSON.stringify(profile));
    },

    getProfileDetail() {
        const data = localStorage.getItem(KEY_PROFILE_DETAIL);
        return data ? JSON.parse(data) : null;
    },

    removeProfileDetail() {
        localStorage.removeItem(KEY_PROFILE_DETAIL);
    },

    // Daftar rombel_id yang diwalikelasi user ini. Disimpan sebagai array
    // karena satu guru bisa jadi wali kelas di lebih dari satu rombel.
    setHomeroomTeacherId(rombel_ids) {
        const data = this.getToken();
        if (!data) return;

        data.homeroom_teacher_id = Array.isArray(rombel_ids) ? rombel_ids : [];
        localStorage.setItem(KEY_TOKEN, JSON.stringify(data));
    },

    getHomeroomTeacherId() {
        return this.getToken()?.homeroom_teacher_id || [];
    },

    isHomeroomTeacher() {
        return this.getHomeroomTeacherId().length > 0;
    },

    decodeToken() {
        const data = this.getToken();
        if (!data) return null;

        try {
            return {
                npsn: data.npsn,
                user_email: data.user_email,
                user_role: data.user_role,
                homeroom_teacher_id: data.homeroom_teacher_id || [],
                ...jwtDecode(data.token),
            };
        } catch (error) {
            console.error('Gagal decode token:', error);
            return null;
        }
    },

    isTokenValid() {
        const decoded = this.decodeToken();
        if (!decoded || !decoded.exp) return false;
        const now = Date.now() / 1000;

        return decoded.exp > now;
    },
};
